export default __webpack_public_path__ + "static/media/detail_one.206bf736.png";